<template>
    <van-popup v-model:show="showNotifyPop" position="top" :round="true" id="riskNotice" :overlay="false">

    <div class="risk_notice_mask" v-show="isVisible" @click="ignoreNoticePopup">
        <div class="risk_notice_content" @click.stop.prevent>
            <van-row>
                <van-col span="24">
                    <span style="text-align: center;">{{ risk_content }}</span>
                </van-col>
                
            </van-row>
            <van-row>
                <van-col span="12" style="align-items: flex-end;" @click="ignoreNoticePopup()">
                    <div class="risk_notice_ignore" style="margin-right: 15px; cursor: pointer;">
                        {{$t('riskControl.ignoreNotice')}}
                    </div>
                </van-col>
                <van-col span="12" style="align-items: center;" @click="onClickNotice()">
                    <div class="risk_notice_readButton" style="margin-right: 15px; cursor: pointer;">
                        {{$t('riskControl.readNotice')}}
                    </div>
                </van-col>
            </van-row>
        </div>
    </div>
    </van-popup>
</template>

<script>
import eventBus from "../../common/js/eventBus";
import {
    ROUTE_RISK_CONTROL,
} from '../../common/js/routes';
import { getStorageSync, setStorageSync } from "../../utils/storage.js";

export default {
    data() {
        return {
            showNotifyPop: false, // Controls the visibility of the popup
            unread_risk_notice: '',
            risk_content: '',  // Risk notice content
            intervalId: '',  // To store interval reference
            isVisible: false,
            audio: ''
        }
    },
    mounted() {
        eventBus.$on('ignoreRiskNotice', this.ignoreNotice); // Listen for the event
        this.autoLogoutHidePopup();
        this.risk_content = getStorageSync('risk_msg_content') || '';
        if(this.risk_content!=''){
            this.isVisible = true;
            this.audio = new Audio();
            this.audio.src = getStorageSync('riskNoticeSound') || '';
            if(getStorageSync('riskNoticeSoundRun') != 1){
                this.audio.play().catch(() => {}); // Handle autoplay restrictions
            }
            setStorageSync('riskNoticeSoundRun', 1);
        }
    },
    methods: {
        autoLogoutHidePopup() {
            setInterval(() => {
                if (!getStorageSync('token')) {
                    if(getStorageSync('risk_msg_id')){
                        eventBus.$emit('ignoreRiskNotice'); // Emit the event
                    }
                }
            }, 1000); // Check every 1 second
        },
        openNoticeAsPopup() {
                this.showNotifyPop = true;  // Show the popup if logged in
                this.risk_content = getStorageSync('risk_msg_content') || '';  // Get content from localStorage
                this.audio = new Audio();
                this.audio.src = getStorageSync('riskNoticeSound') || '';
                if(getStorageSync('riskNoticeSoundRun') != 1){
                    this.audio.play().catch(() => {}); // Handle autoplay restrictions
                }
                setStorageSync('riskNoticeSoundRun', 1);
        },
        ignoreNoticePopup() {  
            setStorageSync("risk_msg_id", '');
            setStorageSync('risk_msg_content', '');
            setStorageSync('riskNoticeSoundRun', 0);
            if (this.audio && typeof this.audio.pause === 'function') {
            this.audio.pause();    
            }
            this.showNotifyPop = false;
            this.isVisible = false;
            // this.$router.back();
        },
        ignoreNotice() {            
            setStorageSync("risk_msg_id", '');
            setStorageSync('risk_msg_content', '');
            setStorageSync('riskNoticeSoundRun', 0);
            if (this.audio && typeof this.audio.pause === 'function') {
            this.audio.pause();      
            }
            this.showNotifyPop = false;
            this.isVisible = false;
        },
        onClickNotice() {
            setStorageSync("risk_msg_id", '');
            setStorageSync('risk_msg_content', '');
            setStorageSync('riskNoticeSoundRun', 0);
            if (this.audio && typeof this.audio.pause === 'function') {
            this.audio.pause();          
            }
            this.risk_content = '';
            this.isVisible = false;
            this.showNotifyPop = false;  // Hide the popup when clicking notice
            this.$router.push(ROUTE_RISK_CONTROL);
        },
    },

}
</script>

<style scoped>
#riskNotice :deep(.van-popup__content) {
    padding: 9px !important;
    width: 88% !important;
    align-items: center !important;
    top: -10%;
    left: 50%;
    transform: translate(-50%, 10%) !important;
    border-radius: 10px !important;
    text-align: center;
}

.risk_notice_mask {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
}

.risk_notice_content {
    padding: 9px !important;
    width: 88vw !important;
    align-items: center !important;
    border-radius: 10px !important;
    text-align: center;
    background: #fff;
}

.risk_notice_readButton {
    background-color: #EE5C35;
    color: white;
    text-align: center;
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid var(--baseRedColor);
    padding: 8px 17px;
    margin-top: 10px;
}

.risk_notice_ignore {
    background-color: white;
    color: #EE5C35;
    text-align: center;
    font-size: 14px;
    border-radius: 8px;
    border: 1px solid var(--baseRedColor);
    padding: 8px 17px;
    margin-top: 10px;
}
</style>
